function stripInlineStyles(element) {
  if (!element) return;

  element.removeAttribute("style");

  element.querySelectorAll("*").forEach(el => {
    el.removeAttribute("style");
  });
}

function processDownloads(root = document) {

  const elements = root.querySelectorAll("p, div, li");

  elements.forEach(el => {

    if (el.dataset.downloadProcessed) return;

    const text = el.textContent.replace(/\s+/g, " ").trim().toLowerCase();

    if (text === "downloads:") {

      el.dataset.downloadProcessed = "true";

      // Header Styling
      el.classList.add("h4", "downloads-header");
      stripInlineStyles(el);
      el.style.marginTop = "20px";

      // Span cleanup (falls Shopify Editor Müll reinpackt)
      el.querySelectorAll("span").forEach(span => {
        span.removeAttribute("style");
      });

      let next = el.nextElementSibling;

      while (next) {

        const nextText = next.textContent.replace(/\s+/g, "").trim();

        if (!nextText) {
          next = next.nextElementSibling;
          continue;
        }

        // ❌ Inline Styles komplett entfernen
        stripInlineStyles(next);

        const links = Array.from(next.querySelectorAll("a"));

        if (!links.length) break;

        // 👉 mehrere Links zusammenfassen
        if (links.length > 1) {
          const firstLink = links[0];

          const combinedText = links
            .map(link => link.textContent.trim())
            .join(", ");

          firstLink.textContent = combinedText;

          links.slice(1).forEach(link => link.remove());

          [...next.childNodes].forEach(node => {
            if (node !== firstLink) node.remove();
          });
        }

        const finalLink = next.querySelector("a");

        if (finalLink) {

          if (!finalLink.dataset.downloadStyled) {

            finalLink.dataset.downloadStyled = "true";

            finalLink.classList.add("download-button");

            stripInlineStyles(finalLink);

            finalLink.setAttribute("target", "_blank");
            finalLink.setAttribute("rel", "noopener noreferrer");

            let href = finalLink.getAttribute("href");
            if (href && href.includes("&p=true")) {
              finalLink.href = href.replace("&p=true", "");
            }
          }
        }

        links.forEach(link => {

          if (link.dataset.downloadStyled) return;

          link.dataset.downloadStyled = "true";

          link.classList.add("download-button");

          stripInlineStyles(link);

          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noopener noreferrer");

          let href = link.getAttribute("href");
          if (href && href.includes("&p=true")) {
            link.href = href.replace("&p=true", "");
          }
        });

        next = next.nextElementSibling;
      }
    }
  });
}

// mehrfach triggern (Shopify-safe)
function initDownloadsFix() {
  processDownloads();
  setTimeout(processDownloads, 500);
  setTimeout(processDownloads, 1500);
}

// Events
document.addEventListener("DOMContentLoaded", initDownloadsFix);
document.addEventListener("shopify:section:load", initDownloadsFix);
document.addEventListener("click", () => {
  setTimeout(processDownloads, 300);
});